import { mediaQuery } from 'constants/ui';

export const panelStyles = {
  width: '100%',
  height: '100%',
  gap: '10px',
  paddingTop: '24px',
  paddingRight: '12px',
  paddingBottom: '12px',
  paddingLeft: '12px',
  backgroundColor: ({ palette }) => palette.background.secondary,
  [mediaQuery.mobile]: {
    gap: '6px',
    paddingTop: '12px',
    paddingRight: '8px',
    paddingBottom: '8px',
    paddingLeft: '8px',
  },
};

export const contentWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  overflow: 'hidden',
  borderRadius: '12px',
  backgroundColor: ({ palette }) => palette.background.paper,
  boxShadow: ({ palette }) => palette.shadow.m,
};
